<template>
    <div class="component-calculator">
        <div class="calculator-wrap wrap">
            <p class="calculator-title">НДФЛка найдет для вас максимальный возврат</p>
            <div class="calculator-content">
                <div class="calculator-steps">
                    <div class="calculator-step" v-show="step === 1">
                        <p class="calculator-question">Вы платите ипотеку?</p>
                        <p class="calculator-question-description">Проценты по ипотеке — это ещё +13% к возврату!</p>
                        <div class="calculator-answers">
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-mortgage" :value="true" v-model="calculator.mortgage" />
                                <span class="answer-text">Да</span>
                                <span class="answer-description" v-show="calculator.mortgage === true">Банки в шоке! За проценты вернём до 390&nbsp;000&nbsp;₽</span>
                            </label>
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-mortgage" :value="false" v-model="calculator.mortgage" />
                                <span class="answer-text">Нет</span>
                                <span class="answer-description" v-show="calculator.mortgage === false">Значит, не придётся вспоминать график платежей. Отлично!</span>
                            </label>
                        </div>
                        <form @submit.prevent="step++" class="calculator-form">
                            <div class="calculator-field" v-if="calculator.mortgage !== null && !isUser">
                                <div class="form-field">
                                    <input
                                        class="input"
                                        name="calculator_firstname"
                                        autocomplete="off"
                                        placeholder="Как Вас зовут?"
                                        v-model="firstname"
                                        type="text"
                                        required
                                    />
                                </div>
                                <p class="calculator-field-description">Чтобы мы обращались к вам по имени</p>

                                <div class="auth-buttons-wrap">
                                    <p class="auth-description">Продолжить в одно касание:</p>
                                    <third-auth-buttons :preClickEvent="saveCalculatorProgress"></third-auth-buttons>
                                </div>
                            </div>
                            <div class="calculator-buttons">
                               <button class="button button-gradient button-next" type="submit" :disabled="calculator.mortgage === null">
                                   Далее
                               </button>
                            </div>
                        </form>
                    </div>

                    <div class="calculator-step" v-show="step === 2">
                        <p class="calculator-question">Вы покупали квартиру/дом/участок?</p>
                        <p class="calculator-question-description">Даже если давно — всё равно можно вернуть налог!</p>
                        <div class="calculator-answers">
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-estate" :value="true" v-model="calculator.estate" />
                                <span class="answer-text">Да</span>
                                <span class="answer-description" v-show="calculator.estate === true">Круто! Вы только что нашли до 260&nbsp;000&nbsp;₽. Поехали дальше?</span>
                            </label>
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-estate" :value="false" v-model="calculator.estate" />
                                <span class="answer-text">Нет</span>
                                <span class="answer-description" v-show="calculator.estate === false">Экономите на агентах по недвижимости? Умно!</span>
                            </label>
                        </div>
                        <div class="calculator-buttons">
                            <button class="button button-prev" @click="step--">
                                Назад
                            </button>
                            <button class="button button-gradient button-next" @click="step++" :disabled="calculator.estate === null">
                                Далее
                            </button>
                        </div>
                    </div>

                    <div class="calculator-step" v-show="step === 3">
                        <p class="calculator-question">{{ displayedFirstname }}, вы тратились на врачей, анализы, лекарства, ДМС? <br>Вы или ваш ребенок учились платно?</p>
                        <p class="calculator-question-description">Даже обычный чек на таблетки и расходы на детский сад могут вернуть деньги в семью!</p>
                        <div class="calculator-answers">
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-social" :value="true" v-model="calculator.social" />
                                <span class="answer-text">Да</span>
                                <span class="answer-description" v-show="calculator.social === true">Здорово! Вернём до 15&nbsp;600&nbsp;₽ в год, и до 300&nbsp;000&nbsp;₽ за дорогостоящее лечение</span>
                            </label>
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-social" :value="false" v-model="calculator.social" />
                                <span class="answer-text">Нет</span>
                                <span class="answer-description" v-show="calculator.social === false">Видимо, у вас железный иммунитет. Завидуем!</span>
                            </label>
                        </div>
                        <form @submit.prevent="checkPhoneStep" class="calculator-form">
                            <div class="calculator-field" v-show="calculator.social !== null && !isUser">
                                <div class="form-field">
                                    <input
                                        class="input masked-phone"
                                        id="calculator_phone"
                                        autocomplete="off"
                                        placeholder="Ваш мобильный телефон"
                                        v-model="phone"
                                        type="tel"
                                    />
                                </div>
                                <p class="calculator-field-description">Для быстрой связи. Обещаем не звонить с рекламой!</p>

                                <div class="auth-buttons-wrap">
                                    <p class="auth-description">Продолжить в одно касание:</p>
                                    <third-auth-buttons :preClickEvent="saveCalculatorProgress"></third-auth-buttons>
                                </div>
                            </div>
                            <div class="calculator-buttons">
                                <button class="button button-prev" type="button" @click="step--">
                                    Назад
                                </button>
                                <button
                                    class="button button-gradient button-next"
                                    type="submit"
                                    :disabled="calculator.social === null"
                                >
                                    Далее
                                </button>
                            </div>
                        </form>
                    </div>

                    <div class="calculator-step" v-show="step === 4">
                        <p class="calculator-question">{{ displayedFirstname }}, у вас есть ИИС или вы покупали акции/облигации (даже через приложение банка)?</p>
                        <div class="calculator-answers">
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-investment" :value="true" v-model="calculator.investment" />
                                <span class="answer-text">Да</span>
                                <span class="answer-description" v-show="calculator.investment === true">Уолл-Стрит отдыхает! Минимум + 52&nbsp;000&nbsp;₽ в год и еще вернем налог с убытков</span>
                            </label>
                            <label class="calculator-answer">
                                <input class="answer-input" type="radio" name="answer-investment" :value="false" v-model="calculator.investment" />
                                <span class="answer-text">Нет</span>
                                <span class="answer-description" v-show="calculator.investment === false">Значит, не теряли деньги на Tesla. Мудро!</span>
                            </label>
                        </div>
                        <form @submit.prevent="step++" class="calculator-form">
                            <div class="calculator-field" v-if="calculator.investment !== null && !isUser">
                                <div class="form-field">
                                    <input
                                        class="input"
                                        name="calculator_email"
                                        autocomplete="off"
                                        placeholder="Email"
                                        v-model="email"
                                        type="email"
                                        required
                                    />
                                </div>
                                <p class="calculator-field-description">Пришлём расчёт и список документов. Проверьте, чтобы не было ошибок!</p>

                                <div class="auth-buttons-wrap">
                                    <p class="auth-description">Продолжить в одно касание:</p>
                                    <third-auth-buttons :preClickEvent="saveCalculatorProgress"></third-auth-buttons>
                                </div>
                            </div>
                            <div class="calculator-buttons">
                                <button class="button button-prev" type="button" @click="step--">
                                    Назад
                                </button>
                                <button class="button button-gradient button-next" type="submit" :disabled="calculator.investment === null">
                                    Далее
                                </button>
                            </div>
                        </form>
                    </div>

                    <template v-if="step === 5">
                        <template v-if="!isUser">
                            <template v-if="!isAlreadyRegistered">
                                <div class="calculator-step" v-show="calculatorNumber">
                                    <p class="calculator-registration-text">
                                        {{ displayedFirstname }}, мы нашли для вас {{ calculatorNumber|formatCurrency }}&nbsp;₽!
                                        <br>Но это только начало — 72% клиентов получают больше
                                    </p>
                                    <p class="calculator-registration-text">Хотите больше вычета — <br />мы знаем, как это сделать!</p>
                                    <p class="calculator-registration-description">Просто оформите заказ на «Максимальный вычет» в личном кабинете — и наш эксперт свяжется с вами, чтобы всё уточнить.</p>
                                    <button class="button button-gradient button-registration" @click="initCreateCalculatorOrder" :disabled="isRegLoading || isCalculatorLoading">
                                        вернуть максимум
                                    </button>
                                </div>
                                <div class="calculator-step" v-show="!calculatorNumber">
                                    <p class="calculator-registration-zero">Кажется, вы — эталон финансовой дисциплины! <br />Наши алгоритмы проверили все возможные расходы, но… ваш кошелек оказался неуязвим для налоговых вычетов. <br />Так держать!</p>
                                    <div class="reg-advantages-block">
                                        <p class="advantages-title">Но вдруг что-то упустили? Зарегистрируйтесь — и мы:</p>
                                        <ul class="advantages-list">
                                            <li class="advantages-list-item">Напомним, когда появятся подходящие траты <br />(ипотека, лечение, обучение)</li>
                                            <li class="advantages-list-item">Первому из всех расскажем о новых вычетах</li>
                                        </ul>
                                    </div>

                                    <button class="button button-gradient button-registration" @click="initCreateCalculatorOrder" :disabled="isRegLoading || isCalculatorLoading">
                                        Узнать о новых вычетах
                                    </button>
                                </div>
                            </template>
                            <template v-if="isAlreadyRegistered">
                                <div class="calculator-step">
                                    <p class="calculator-registration-already-reg">Пользователь с такими данными уже зарегистрирован — войдите, пожалуйста, в свой личный кабинет</p>
                                    <picture>
                                        <source srcset="/img/door.jpg, /img/door@2x.jpg 2x" type="image/jpeg">
                                        <img loading="lazy" src="/img/door.jpg" alt="" class="calculator-already-reg-image" width="304" height="264">
                                    </picture>
                                    <a class="button button-gradient button-login" href="/user/login/">
                                        войти в личный кабинет
                                    </a>
                                </div>
                            </template>
                        </template>
                        <template v-if="isUser">
                            <div class="calculator-step" v-show="calculatorNumber">
                                <p class="calculator-registration-text">
                                    {{ displayedFirstname }}, мы нашли для вас {{ calculatorNumber|formatCurrency }}&nbsp;₽!
                                    <br>Но это только начало — 72% клиентов получают больше
                                </p>
                                <p class="calculator-registration-text">Хотите больше вычета — <br />мы знаем, как это сделать!</p>
                                <p class="calculator-registration-description">Просто оформите заказ на «Максимальный вычет» в личном кабинете — и наш эксперт свяжется с вами, чтобы всё уточнить.</p>
                                <button class="button button-gradient button-registration" @click="initCreateCalculatorOrder" :disabled="isRegLoading || isCalculatorLoading">
                                    Максимальный возврат
                                </button>
                            </div>
                            <div class="calculator-step" v-show="!calculatorNumber">
                                <p class="calculator-registration-zero">Поздравляем! Вы нас озадачили. <br />Наш алгоритм в ступоре — он не нашел ни одного вычета за вами</p>
                                <div class="reg-advantages-block">
                                    <p class="advantages-title">Но мы не сдаемся! Оставьте заказ — и мы:</p>
                                    <ul class="advantages-list">
                                        <li class="advantages-list-item">Перепроверим прошлые годы (вдруг пропустили что-то?)</li>
                                        <li class="advantages-list-item">Пришлем уведомление, как только появится новый вычет <br />(например, купите квартиру/машину/золотого дракона)</li>
                                    </ul>
                                </div>

                                <button class="button button-gradient button-registration" @click="initCreateCalculatorOrder" :disabled="isRegLoading || isCalculatorLoading">
                                    Найдите мне вычет
                                </button>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="calculator-progress">
                    <div
                        v-for="stepNumber in stepMax"
                        :key="'calculator-progress-' + stepNumber"
                        :class="{ active: stepNumber <= step }"
                        class="progress-block"
                    >
                        <img src="/img/svg/icon-calculator-coin.svg" alt="" width="24" height="24" class="icon-coin coin-active" />
                        <img src="/img/svg/icon-calculator-coin-disabled.svg" alt="" width="24" height="24" class="icon-coin coin-disabled" />
                    </div>
                </div>
                <p class="progress-description">Осталось немного!</p>
                <div class="form-checkbox" v-show="!isUser && step === 5 && !isAlreadyRegistered">
                    <input
                        class="checkbox"
                        id="calculator-privacy"
                        type="checkbox"
                        checked
                        v-model="privacy"
                        required
                        name="calculator-privacy"
                    >
                    <label for="calculator-privacy" class="label">
                        Оставляя контактные данные, вы соглашаетесь с <a href="/documents/privacy/" target="_blank" class="privacy-link">политикой конфиденциальности</a> и даете согласние на обработку персональных данных, а также подтверждаете, что <a href="/documents/eula/" target="_blank" class="privacy-link">Ознакомлены и согласны с условиями Договора</a>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Notice } from '../js/utils/notice';
import registrationHelper from '../js/utils/registrationHelper';
import orderHelper from '../js/utils/orderHelper';
import { api } from '../js/api';
import Cookies from 'js-cookie';
import ThirdAuthButtons from './ThirdAuthButtons.vue';

export default {
    name: 'Calculator',

    mixins: [
        registrationHelper,
        orderHelper
    ],

    components: {
        ThirdAuthButtons
    },

    props: {
        isUser: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            step: 1,
            stepMax: 6,
            calculator: {
                estate: null, // недвижимость
                mortgage: null, // ипотека
                social: null, // образование, лечение
                investment: null // иис
            },
            firstname: '',
            email: '',
            phone: '',
            privacy: true,
            isRegLoading: false,
            isCalculatorLoading: false,
            isAlreadyRegistered: false
        };
    },

    watch: {
        step(value) {
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'calculator_component_step_' + value }}));

            if (this.isUser && value === 5) {
                this.saveCalculator();
            }
        }
    },

    computed: {
        calculatorNumber() {
            let result = 0;
            if (this.calculator.estate) {
                result += 260000;
            }

            if (this.calculator.mortgage) {
                result += 390000;
            }

            if (this.calculator.social) {
                result += 15600;
            }

            if (this.calculator.investment) {
                result += 52000;
            }

            return result;
        },

        displayedFirstname() {
            if (this.user && this.user.hasOwnProperty('firstname')) {
                return this.user.firstname;
            }
            return this.firstname;
        }
    },

    methods: {
        checkPhoneStep() {
            if (this.isUser) {
                this.step++;
                return;
            }

            if (!this.phone || this.phone.length < 10) {
                new Notice().warn('Нужно указать номер мобильного телефона', {
                    timeout: 10000
                });
                return;
            }

            this.step++;
        },

        initCreateCalculatorOrder() {
            if (!this.isUser) {
                this.initRegistration()
                    .then(() => {
                        this.saveCalculator().then(() => {
                            this.createCalculatorOrder();
                        });
                    })
                    .catch(() => undefined);
            } else {
                this.createCalculatorOrder();
            }
        },

        createCalculatorOrder() {
            api.get('/order/list').then((res) => {
                const ORDER_SID_BV = 40;
                this.initCreateOrder(ORDER_SID_BV, res.data);
            });
        },

        saveCalculator() {
            const dataForSave = {
                send_to_chat: false,
                salary: 0,
                estate: this.calculator.estate,
                morgage: this.calculator.mortgage,
                treatment: this.calculator.social,
                investment: this.calculator.investment
            };

            return api.post('/v3/user/selectionCalculator', dataForSave).catch(() => undefined);
        },

        initRegistration() {
            if (!this.privacy) {
                new Notice().info('Для продолжения нужно принять условия сервиса', {
                    timeout: 10000
                });
                return Promise.reject();
            }

            const body = Object.assign(this.getDefaultRegistrationParams(), {
                phone: '7' + this.phone,
                firstname: this.firstname,
                email: this.email,
                not_add_autoorder: 1
            });

            this.isRegLoading = true;

            return api.post('/user/shortReg', body)
                .then((res) => {
                    const errors = res.data.errors;

                    if (errors.hasOwnProperty('phone') && errors.phone) {
                        if (errors.phone[0] === 'Номер мобильного телефона уже зарегистрирован') {
                            this.isAlreadyRegistered = true;
                        } else {
                            new Notice().error(errors.phone[0], {
                                timeout: 10000
                            });
                            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'calculator_component_reg_error' }}));
                            this.step = 3;
                            throw false;
                        }
                    }

                    if (errors.hasOwnProperty('firstname') && errors.firstname) {
                        new Notice().error(errors.firstname[0], {
                            timeout: 10000
                        });
                        document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'calculator_component_reg_error' }}));
                        this.step = 1;
                        throw false;
                    }

                    if (errors.hasOwnProperty('email') && errors.email) {
                        if (errors.email[0] === 'Email уже зарегистрирован') {
                            this.isAlreadyRegistered = true;
                        } else {
                            new Notice().error(errors.email[0], {
                                timeout: 10000
                            });
                            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'calculator_component_reg_error' }}));
                            this.step = 4;
                            throw false;
                        }
                    }

                    if (Object.keys(errors).length) {
                        throw false;
                    }

                    if (res.data.data.hasOwnProperty('JWT')) {
                        Cookies.set('user_token', res.data.data.JWT, {expires: 3650, domain: process.env.COOKIE_DOMAIN, secure: true});

                        document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'reg_button' }}));
                        document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'calculator_component_reg' }}));
                    }
                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    this.isRegLoading = false;
                });
        },

        saveCalculatorProgress() {
            localStorage.setItem('callback_url', '/#home-calculator');
            const dataForSave = {
                step: this.step,
                calculator: this.calculator
            };

            localStorage.setItem('calculator_progress', JSON.stringify(dataForSave));
        },

        loadCalculatorProgress() {
            const progressRawData = localStorage.getItem('calculator_progress');
            localStorage.removeItem('calculator_progress');
            if (!progressRawData) {
                return;
            }

            const progressData = JSON.parse(progressRawData);

            if (!progressData) {
                return;
            }

            if (progressData.step >= 1 && progressData.step <= this.stepMax) {
                this.step = progressData.step;
            }

            if (progressData.calculator) {
                this.calculator = progressData.calculator;
            }
        }
    },

    created() {
        this.loadCalculatorProgress();
    }
};
</script>
